import { render, staticRenderFns } from "./ProcessingTotalEmbassySubmitReport.vue?vue&type=template&id=2fa9bb61&scoped=true&"
import script from "./ProcessingTotalEmbassySubmitReport.vue?vue&type=script&lang=js&"
export * from "./ProcessingTotalEmbassySubmitReport.vue?vue&type=script&lang=js&"
import style0 from "./ProcessingTotalEmbassySubmitReport.vue?vue&type=style&index=0&id=2fa9bb61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa9bb61",
  null
  
)

export default component.exports